// components/TravelpayoutsFlightWidget.tsx
"use client";

import { useState } from "react";

export default function TravelpayoutsFlightWidget() {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="relative w-full min-h-[850px]">
      {!loaded && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-white dark:bg-gray-900">
          <div className="w-8 h-8 border-2 border-purple-200 border-t-purple-600 rounded-full animate-spin" />
          <span className="text-sm text-gray-400">Loading flight search…</span>
        </div>
      )}
      <iframe
        src="/flights-widget.html"
        title="Flight Search"
        onLoad={() => setLoaded(true)}
        className="w-full min-h-[850px] border-0 block"
        style={{ colorScheme: "light" }}
      />
    </div>
  );
}
